export const reportCodes = {
  CreditMemo: 'CREDIT_MEMO',
  PriceQuote: 'PQ_REPORT',
  BVPriceQuote: 'BV_PQ_REPORT',
  BVCustomPriceQuote: 'BV_CUSTPQ_REPORT',
}
